import "@/app/styles/index.css"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "@/app/App"
import { bootstrap, BootstrapScreen } from "@/app/bootstrap"

function getRootElement() {
  const rootElement = document.getElementById("root")
  if (!rootElement) {
    throw new Error("Root element not found")
  }
  return rootElement
}

const initializeApp = async () => {
  const root = createRoot(getRootElement())

  root.render(
    <StrictMode>
      <BootstrapScreen />
    </StrictMode>
  )

  const { router } = await bootstrap()

  root.render(
    <StrictMode>
      <App router={router} />
    </StrictMode>
  )
}

initializeApp()
